import React from 'react';
import ReactDOM from 'react-dom/client';

// Self-hosted type system — see index.css for role assignments (display / body / mono)
import '@fontsource/space-grotesk/500.css';
import '@fontsource/space-grotesk/600.css';
import '@fontsource/space-grotesk/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/500.css';

import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// Performance monitoring
if (process.env.NODE_ENV === 'production') {
  // Add performance monitoring here if needed
  console.log('Portfolio loaded in production mode');
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
